import 'react-table/react-table.css';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import * as moment from 'moment';
import PropTypes from 'prop-types';
import get from 'get-value';
import {fetchClaimsFullTextSearchPageData} from '../../../actions/claims/actionClaimsFullTextSearchPage';
import {IconEdit, PrimaryIcon} from '../../common/Button';
import {moduleRoles} from '../../../utils/roles';
import {editClaimsListButtonVisibility} from '../../../constants/claimsTicketRights';
import Table from '../../common/table/TicketTable';
import fulltextSearchMessages from '../../../intl/claims/fulltextSearchMessages';
import {domains} from '../../../constants/Utils';

class FullTextSearchClaimsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listDefaultPageSize: 10,
            listDefaultSort: [{id: 'ticketNumber', desc: true}],
        };
        this.handleFetchData = this.handleFetchData.bind(this);
    }

    handleFetchData(state) {
        this.props.fetchClaimsFullTextSearchPageData(
            state.pageSize,
            state.sorted,
            state.cursor,
            state.isNextFromPivot,
            get(this, 'props.listDefaultFilters.1', {default: {}}),
            this.normalizeFiltered(get(this, 'props.listDefaultFilters.0', {default: []}))
        );
        this.setState({
            listDefaultPageSize: state.pageSize,
            listDefaultSort: state.sorted,
        });
    }

    normalizeFiltered = state => {
        return state
            .map(filterItem => {
                if (filterItem.id === 'from' || filterItem.id === 'to') {
                    return {
                        id: filterItem.id,
                        value: moment(filterItem.value, 'YYYY-MM-DD').add(12, 'hours').toISOString()
                    };
                } else if (filterItem.value instanceof Date) {
                    return {
                        id: filterItem.id,
                        value: moment(filterItem.value).add(12, 'hours').toISOString().substr(0, 10)
                    };
                } else {
                    return filterItem;
                }
            });
    };

    render() {
        const {columns, data, pages, isLoading, handleEditClick, listDefaultFilters, isNextPage, isNextFromPivot, dealerNumber} = this.props;
        return (
            <div className="container-fluid text-center p-0">
                <div className="row">
                    <div className="col">
                        <Table
                            columns={[
                                {
                                    id: 'ticketNumber',
                                    accessor: 'ticket.ticketNumber',
                                    filterable: false,
                                    message: fulltextSearchMessages.TABLE_TICKET_NUMBER,
                                    Cell: (row) => <Link to={`view/${row.original.id}`}>{row.value}</Link>
                                },
                                ...columns]}
                            toolButtons={[
                                {
                                    handleClick: handleEditClick,
                                    component: <PrimaryIcon className="btn btn-sm"
                                                            title="Edit"
                                                            type="button"
                                                            key="editButton">
                                        <IconEdit/>
                                    </PrimaryIcon>
                                }
                            ]}
                            isLoading={isLoading}
                            data={data}
                            pages={pages}
                            handleFetchData={this.handleFetchData}
                            isNextPage={isNextPage}
                            isNextFromPivot={isNextFromPivot}
                            defaultFiltered={listDefaultFilters}
                            defaultSorting={this.state.listDefaultSort}
                            defaultPageSize={this.state.listDefaultPageSize}
                            buttonVisibility={editClaimsListButtonVisibility[moduleRoles.isDealerClaims(this.props.userRoles) ? 'DEALER' : 'EDITOR']}
                            dealerNumber={moduleRoles.isDealerClaims(this.props.userRoles) ? this.props.dealerNumber : 'EDITOR'}
                            editorGroups={moduleRoles.isEditorClaims(this.props.userRoles) ? moduleRoles.getEditorGroups(domains.CLAIMS, this.props.userRoles).map(e => e.group) : false}
                            toolSortable={true}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

FullTextSearchClaimsTable.propTypes = {
    handleEditClick: PropTypes.func.isRequired,
    columns: PropTypes.array.isRequired,
    listDefaultFilters: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
    isLoading: state.claimsFullTextSearchPage.isTableLoading,
    data: state.claimsFullTextSearchPage.fullTextData,
    isNextPage: state.claimsFullTextSearchPage.isNextPage,
    isNextFromPivot: state.claimsFullTextSearchPage.isNextFromPivot,
    pages: state.claimsFullTextSearchPage.pages,
    userRoles: state.profile.userDetail.roles,
    dealerNumber: state.profile.userDetail.dealerNumber,
});

export default connect(mapStateToProps, {
    fetchClaimsFullTextSearchPageData
})(FullTextSearchClaimsTable);
